exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-bar[data-v-4e6120d2]{display:flex;align-items:flex-start;justify-content:flex-start;flex-wrap:wrap;margin-bottom:1rem}.filter-title[data-v-4e6120d2]{font-weight:700;margin:0;font-size:18px}@media screen and (min-width:425px){.filter-title[data-v-4e6120d2]{font-size:calc(12.13793px + 1.37931vw)}}@media screen and (min-width:1440px){.filter-title[data-v-4e6120d2]{font-size:32px}}", ""]);

// exports
